export enum ProjectInformationSheetState {
  RECEIVED = "received",
  NOT_RECEIVED = "notReceived",
}
